import { useRef, useState } from 'react';
import DisplayTagsPattern from '../../commonComponents/DisplayTagsPattern';
import { Space, Tag, Typography } from 'antd';
import TextArea from 'antd/es/input/TextArea';
const SingleAdaptation = ({ adaptation, outputFilenamePattern, patternOptionsArr, updateOutputPattern, angleIndex, adaptaionIndex, angleId, adaptationId, problemPatterns }) => {
    const textAreaRef = useRef(null);
    const [cursorPositions, setCursorPositions] = useState({
        start: outputFilenamePattern?.length,
        end: outputFilenamePattern?.length,
    });
    const isProblemPattern = problemPatterns.some(pattern => pattern.angleId === angleId && pattern.adaptationId === adaptationId);
    // console.log({ isProblemPattern, problemPatterns, angleId, adaptationId: adaptationId });
    const catchPointerPosition = e => {
        const { selectionStart, selectionEnd } = e.currentTarget;
        setCursorPositions({ start: selectionStart, end: selectionEnd });
    };
    const updateText = (tagValue, adaptationIndex) => {
        const { start, end } = cursorPositions;
        const value = outputFilenamePattern;
        const updatedValue = value ? value.substring(0, start) + tagValue + value.substring(end) : tagValue;
        const textBeforeCursor = value ? `${value.substring(0, start)}${tagValue}` : tagValue;
        setCursorPositions({ start: textBeforeCursor.length, end: textBeforeCursor.length });
        console.log('updated value: ', updatedValue, textBeforeCursor);
        updateOutputPattern(updatedValue, angleIndex, adaptationIndex);
    };
    return (
        <div className="adaptationContainer addBorder">
            <div className="adaptaionDetails">
                <Typography.Title level={5} style={{ margin: 0 }}>
                    {adaptation?.name}
                </Typography.Title>
                {adaptation?.clientAlias && <Typography className="smallTextSize">Client Alias: {adaptation?.clientAlias}</Typography>}
                {adaptation?.alignment && <Typography className="smallTextSize">Alignment: {adaptation?.alignment}</Typography>}
                {adaptation?.fileFormats && <Typography className="smallTextSize">Formats: {adaptation?.fileFormats}</Typography>}
                {adaptation?.maxFileSizeMB && <Typography className="smallTextSize">Max. File Size: {adaptation?.maxFileSizeMB}MB</Typography>}
                {adaptation?.dpi && <Typography className="smallTextSize">dpi: {adaptation?.dpi}</Typography>}
                {adaptation?.shadow && <Typography className="smallTextSize">Shadow: {adaptation?.shadow}</Typography>}
                {adaptation?.background?.hex && (
                    <>
                        <Typography className="smallTextSize">
                            Background:{' '}
                            <span
                                style={{
                                    backgroundColor: adaptation?.background?.hex,
                                    padding: '0 5px',
                                    margin: '3px',
                                    border: '1px solid black',
                                }}
                            ></span>{' '}
                            {adaptation?.background?.hex}
                        </Typography>
                    </>
                )}
                {adaptation?.dimensions && (
                    <Typography className="smallTextSize">
                        {adaptation?.dimensions?.height &&
                            adaptation?.dimensions?.width &&
                            `Dimensions : ${adaptation?.dimensions?.width}x${adaptation?.dimensions?.height}`}
                    </Typography>
                )}
                {adaptation?.cropType && (
                    <Typography className="smallTextSize">
                        {adaptation?.cropType.from && `From : ${adaptation?.cropType.from}`}
                        <br />
                        {adaptation?.cropType.to && `    To : ${adaptation?.cropType.to}`}
                    </Typography>
                )}
                {adaptation?.margins && (
                    <Typography className="smallTextSize">
                        {![undefined, null, ''].includes(adaptation?.margins.top) ? `Top : ${adaptation?.margins.top}` : null}
                        {![undefined, null, ''].includes(adaptation?.margins.bottom) ? `    Bottom : ${adaptation?.margins.bottom}` : null}
                        {![undefined, null, ''].includes(adaptation?.margins.left) ? `    Left : ${adaptation?.margins.left}` : null}
                        {![undefined, null, ''].includes(adaptation?.margins.right) ? `    Right : ${adaptation?.margins.right}` : null}
                    </Typography>
                )}
            </div>
            <div className="inputDiv" style={{ border: isProblemPattern ? '1px solid red' : 'none' }}>
                Output Filename Pattern:
                {outputFilenamePattern && (
                    <DisplayTagsPattern
                        pattern={outputFilenamePattern}
                        patternOptions={patternOptionsArr?.options}
                        setPattern={newPattern => updateOutputPattern(newPattern, angleIndex, adaptaionIndex)}
                    />
                )}
                <TextArea
                    rows={3}
                    ref={textAreaRef}
                    style={{ width: '100%', marginBottom: '5px', marginTop: '8px' }}
                    value={outputFilenamePattern}
                    size="small"
                    placeholder="Enter the pattern"
                    onChange={e => {
                        updateOutputPattern(e.target.value, angleIndex, adaptaionIndex);
                    }}
                    onBlur={catchPointerPosition}
                />
                {isProblemPattern && <Typography className="smallTextSize">Problem Pattern</Typography>}
                Click to add in Pattern:{' '}
                <Space size={[0, 8]} wrap>
                    {patternOptionsArr?.options?.map((tag, i) => (
                        <Tag key={i} style={{ cursor: 'pointer' }} onClick={() => updateText(tag.value, adaptaionIndex)}>
                            {tag.key}
                        </Tag>
                    ))}
                </Space>
            </div>
        </div>
    );
};
export default SingleAdaptation;
